import { CaptureInterval } from "../../../../lib/alt1/capture";
import { deps } from "../../../dependencies";
import { Transform, Vector2 } from "../../../../lib/math";
import { ScanSolving } from "./ScanSolving";
import { Alt1Overlay } from "../../../../lib/alt1/overlay/Alt1Overlay";
export class ScanMinimapOverlay extends Alt1Overlay {
    constructor(minimapreader, settings, role) {
        super();
        this.minimapreader = minimapreader;
        this.settings = settings;
        this.role = role;
        this.range = 10;
    }
    begin() {
        super.begin();
        if (!deps().app.in_alt1)
            return;
        this.lifetime_manager.bind(this.minimap_interest = this.minimapreader.subscribe({
            options: (time) => ({
                interval: CaptureInterval.fromApproximateInterval(100),
                refind_interval: CaptureInterval.fromApproximateInterval(10000)
            }),
            handle: (value) => {
                this.rerender();
            }
        }));
    }
    end() {
        super.end();
        if (!deps().app.in_alt1)
            return;
    }
    renderWithBuilder(overlay) {
        const value = this.minimap_interest.lastNotification();
        const minimap = value.value;
        const settings = this.settings.value();
        if (value.value
            && ((this.role == "scantree" && settings.show_minimap_overlay_scantree) || (this.role == "manual" && settings.show_minimap_overlay_simple))) {
            ScanMinimapOverlay.last_known_ppt =
                settings.minimap_overlay_automated_zoom_detection
                    ? value.value.pixelPerTile() ?? ScanMinimapOverlay.last_known_ppt
                    : settings.minimap_overlay_zoom_manual_ppt;
            // If there's no known pixels per tile value, abort
            if (ScanMinimapOverlay.last_known_ppt == null)
                return;
            const unit_square = [
                { x: 1, y: 1 },
                { x: 1, y: -1 },
                { x: -1, y: -1 },
                { x: -1, y: 1 },
            ];
            if (settings.show_triple_ping) {
                const scale = ((this.range * 2 + 1) / 2) * ScanMinimapOverlay.last_known_ppt;
                const transform = Transform.chain(Transform.translation(minimap.center()), Transform.rotationRadians(-minimap.compassAngle.get()), Transform.scale({ x: scale, y: scale }));
                overlay.polyline(unit_square.map(v => Vector2.transform_point(v, transform)), true, {
                    color: ScanSolving.PulseColors.triple
                });
            }
            if (settings.show_double_ping) {
                const scale = ((this.range * 4 + 1) / 2) * ScanMinimapOverlay.last_known_ppt;
                const transform2 = Transform.chain(Transform.translation(minimap.center()), Transform.rotationRadians(-minimap.compassAngle.get()), Transform.scale({ x: scale, y: scale }));
                overlay.polyline(unit_square.map(v => Vector2.transform_point(v, transform2)), true, {
                    color: ScanSolving.PulseColors.double
                });
            }
        }
    }
    setRange(range) {
        this.range = range;
        return this;
    }
}
(function (ScanMinimapOverlay) {
    ScanMinimapOverlay.last_known_ppt = 4; // Assume mimimum minimap zoom by default
})(ScanMinimapOverlay || (ScanMinimapOverlay = {}));
